/**
 * @module lib/appserver/entityHeaders/studentLinked
 * Common interface for all student-linked entities.
 * These entities are also implicitly school-linked.
 */

import { aggregateStudentID } from "lib/appserver/aggregate";
import * as schoolLinked from "lib/appserver/entityHeaders/schoolLinked";

export const defaultProperties = {
  ...schoolLinked.defaultProperties,
  remoteStudentID: undefined,
  studentID: undefined,
}

export function appserverAdapter(rawEntity) {
  const props = schoolLinked.appserverAdapter(rawEntity);
  props.remoteStudentID = rawEntity.student_fk;
  props.studentID = aggregateStudentID(props);
  return props;
}



// WEBPACK FOOTER //
// ./src/lib/appserver/entityHeaders/studentLinked.js